import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from '../locales/ru/shell.json';

const shellResources = {
  ru,
};

if (!i18n.isInitialized) {
  void i18n
    .use(initReactI18next)
    .init({
      resources: {
        ru: { shell: shellResources.ru },
      },
      defaultNS: 'shell',
      ns: ['shell'],
      supportedLngs: ['ru'],
      lng: 'ru',
      fallbackLng: 'ru',
      load: 'languageOnly',
      interpolation: {
        escapeValue: false,
      },
    });
} else {
  i18n.addResourceBundle('ru', 'shell', shellResources.ru, true, true);
}

export default i18n;
